import {
  Backdrop,
  Box,
  Button,
  Dialog,
  Stack,
  Typography,
} from "@mui/material";
import InputField from "components/ui/inputField";
import { useFormik } from "formik";
import useApi from "hooks/useApi";
import { TfiExchangeVertical } from "react-icons/tfi";
import { toast } from "react-toastify";
import ReactLoading from "react-loading";
import * as yup from "yup";
import AsteriskHighlighter from "components/ui/AsteriskHighlighter";

const SmsConfirm = ({
  open,
  setOpen,
  selectedRows,
  smsBody,
  route = "",
  onAction = () => {},
}) => {
  const initialValues = {
    sms_body: smsBody || "",
    selected_ids: selectedRows,
    route,
  };

  const validationSchema = yup.object({
    sms_body: yup.string().required("SMS body is required"),
  });

  const { fetchData, loading } = useApi();

  const onSubmit = async (data) => {
    const toastId = toast.loading("Sending SMS...", {
      position: "bottom-right",
      autoClose: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
    });

    try {
      let endpoint = {
        method: "post",
        url: "/api/admin/sms/send-bulk-sms",
        data,
      };

      formik.resetForm();
      setOpen(false);
      onAction(true);

      const result = await fetchData(endpoint, false);

      if (result.success) {
        toast.update(toastId, {
          render: result?.message || "SMS sent successfully!",
          type: "success",
          isLoading: false,
          autoClose: false,
          closeOnClick: true,
        });
      }
    } catch (error) {
      toast.update(toastId, {
        render:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to send SMS",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const handleConfirm = () => {
    formik.handleSubmit();
  };

  const handleCancel = () => {
    formik.resetForm();
    setOpen(false);
    onAction(true);
  };
  const handleClose = () => {
    // if (loading) return;
    setOpen(false);
    onAction(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& div": { borderRadius: "8px" },
      }}
    >
      <Box sx={{ width: "450px" }}>
        <Box
          sx={{
            paddingTop: "20px",
            fontSize: "30px",
            fontWeight: "500",
            color: "#0cb367",
            textAlign: "center",
          }}
        >
          <TfiExchangeVertical />
        </Box>
        <Box
          sx={{
            marginTop: "-5px",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          Confirm Send SMS
        </Box>

        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "center",
            color: "text.secondary",
            padding: "10px",
          }}
        >
          Click <i style={{ fontWeight: 500 }}>"Send SMS"</i> to confirm sending
          the SMS to the selected contacts.
          <br /> If you wish to not send the SMS, click{" "}
          <i style={{ fontWeight: 500 }}>"Don't Send SMS"</i>.
        </Typography>

        {loading && (
          <Backdrop
            open={true}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.75)",
              zIndex: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactLoading
              type="spinningBubbles"
              color="#364574"
              height={50}
              width={50}
            />
          </Backdrop>
        )}
        <Box padding={2}>
          <AsteriskHighlighter label="SMS Body *" />
          <InputField
            formik={formik}
            name="sms_body"
            multiline
            rows={8}
            sx={{ width: "100%" }}
            // disabled
          />
        </Box>
        <Box sx={{ backgroundColor: "#f8f8f8" }}>
          <Stack
            direction="row"
            gap="10px"
            justifyContent="center"
            padding="15px"
          >
            {" "}
            <Button onClick={handleCancel}>Don't Send SMS</Button>
            <Button variant="solid" onClick={handleConfirm}>
              Send SMS
            </Button>
          </Stack>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SmsConfirm;
